import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storeWalletAmount: localStorage.getItem("localWalletAmount") || 0,
  loading: false,
  error: null,
};

const walletSlice = createSlice({
  name: "walletStore",
  initialState,
  reducers: {
    fetchWalletStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchWalletSuccess: (state, action) => {
      state.storeWalletAmount = action.payload;
      state.loading = false;
      localStorage.setItem("localWalletAmount", action.payload);
    },
    fetchWalletFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchWalletStart, fetchWalletSuccess, fetchWalletFailure } = walletSlice.actions;
export default walletSlice.reducer;
